import { ReactNode } from 'react';

import { cn } from 'utils/cn';

type BadgeTypes = 'green' | 'yellow' | 'orange';

interface IProps {
  bageText: string;
  title?: string;
  description: string | ReactNode;
  badgeType: BadgeTypes;
  isPDF?: boolean;
}

export const FeasibilityReportCard = ({
  bageText,
  title = '',
  description,
  badgeType,
  isPDF,
}: IProps) => (
  <>
    <div className={`w-full flex mb-6 ${!isPDF ? 'md:hidden' : 'break-inside-avoid'}`}>
      <div className={cn(
        'flex-shrink-0 p-2.5 border rounded-xl h-fit max-w-44 w-full text-center mr-6 font-bold',
        { 'bg-[#FFFCE2] border-[#F2C115] text-[#F2C115]': badgeType === 'yellow' },
        { 'bg-[#E8FCF4] border-[#11AC6B] text-[#11AC6B]': badgeType === 'green' },
        { 'bg-[#FCF5EF] border-[#F8781B] text-[#F8781B]': badgeType === 'orange' },
      )}>{bageText}</div>
      <div>
        {title && <div className="mb-2 font-bold text-black">{title}</div>}
        <div className='text-[#757575]'>{description}</div>
      </div>
    </div>
    <div className={`w-full hidden mb-6 flex-col  ${!isPDF ? 'md:flex' : ''}`}>
      <div className="flex items-center mb-2">
        {title && <div className="font-bold text-black mr-3">{title}</div>}
        <div className={cn(
          'p-2.5 border rounded-xl h-fit min-w-36 max-w-44 w-full text-center mr-6 font-bold pt-1 pb-1$',
          { 'bg-[#FFFCE2] border-[#F2C115] text-[#F2C115]': badgeType === 'yellow' },
          { 'bg-[#E8FCF4] border-[#11AC6B] text-[#11AC6B]': badgeType === 'green' },
          { 'bg-[#FCF5EF] border-[#F8781B] text-[#F8781B]': badgeType === 'orange' },
        )}>{bageText}</div>
      </div>
      <div className='text-[#757575]'>{description}</div>
    </div>
  </>
);
